import get from 'lodash.get';

export const getSelectedSku = (item, skuId) => {
    return (get(item, 'skus') || []).find(sku => sku.serviceId === skuId);
};
